import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#777e90",
      "fill-rule": "evenodd",
      d: "M3.688 4.246a3.715 3.715 0 0 0-3.483 3.44C.097 9.074 0 10.682 0 12s.097 2.926.205 4.314a3.715 3.715 0 0 0 3.483 3.44C5.685 19.878 8.537 20 12 20s6.315-.122 8.312-.246a3.715 3.715 0 0 0 3.483-3.44C23.903 14.926 24 13.318 24 12s-.096-2.926-.205-4.314a3.715 3.715 0 0 0-3.483-3.44A136 136 0 0 0 12 4c-3.463 0-6.315.122-8.312.246m11.064 6.922-3.197-2.132A1 1 0 0 0 10 9.868v4.263a1 1 0 0 0 1.555.832l3.197-2.131a1 1 0 0 0 0-1.664",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }